import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

/* Simple reusable page for basic info pages */
const pgStyle = { padding: '0.7rem 1.1rem', background: '#f0faf4', border: '1px solid #b7e4c7', borderRadius: '8px', color: '#1a3c5e', fontSize: '0.9rem', lineHeight: 1.7, marginBottom: '1rem' };

// ── Enrollment List
export function EnrollmentList() {
    return (
        <div className="page-wrapper"><Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Students Corner › Enrollment Students List</p>
                <h1>Enrollment Students List</h1><p>College enrollment records by academic year.</p>
            </div>
            <div className="page-content">
                <div className="info-card"><h2>Enrollment Data</h2><p style={pgStyle}>📌 Enrollment student lists are maintained by the college office and updated at the beginning of each academic year. For the official enrollment data, contact the college at <a href="mailto:ascnighoj@gmail.com" style={{ color: '#2d6a4f' }}>ascnighoj@gmail.com</a> or call (02488) 230438.</p></div>
            </div>
            <Footer /></div>
    );
}

// ── Old Question Papers
export function OldQuestionPapers() {
    return (
        <div className="page-wrapper"><Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Students Corner › Old Question Papers</p>
                <h1>Old Question Papers</h1><p>Previous year question papers to help students prepare for examinations.</p>
            </div>
            <div className="page-content">
                <div className="info-card"><h2>Available Papers</h2><p style={pgStyle}>📌 Old question papers are uploaded by the college admin. Currently, papers are being compiled and will be made available for download shortly. Meanwhile, students may also access papers on the SPPU website.</p>
                    <div className="ext-links"><a href="https://www.unipune.ac.in" target="_blank" rel="noreferrer" className="ext-link-chip">🔗 SPPU Website</a></div>
                </div>
            </div>
            <Footer /></div>
    );
}

// ── Government Scholarship
export function GovernmentScholarship() {
    return (
        <div className="page-wrapper"><Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Students Corner › Government Scholarship</p>
                <h1>Government Scholarship</h1><p>State and central government scholarship schemes for eligible students.</p>
            </div>
            <div className="page-content">
                <div className="info-card"><h2>Maharashtra State Government Scholarships</h2>
                    <ul>
                        <li><strong>Mahadbt Portal</strong> — Scholarship for SC, ST, OBC, VJNT, SBC, EWS students. Apply at mahadbt.maharashtra.gov.in.</li>
                        <li><strong>EBC Scholarship</strong> — For economically backward class students.</li>
                        <li><strong>GOI Post Matric Scholarship</strong> — Central Government scheme for SC/ST.</li>
                        <li><strong>Rajarshi Chhatrapati Shahu Maharaj Shikshan Shulkh Scholarship (EWS)</strong> — For EWS category students.</li>
                    </ul>
                    <div className="ext-links">
                        <a href="https://mahadbt.maharashtra.gov.in" target="_blank" rel="noreferrer" className="ext-link-chip">🔗 Mahadbt Portal</a>
                    </div>
                </div>
            </div>
            <Footer /></div>
    );
}

// ── University Scholarship
export function UniversityScholarship() {
    return (
        <div className="page-wrapper"><Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Students Corner › University Scholarship</p>
                <h1>University Scholarship</h1><p>Scholarships awarded by Savitribai Phule Pune University.</p>
            </div>
            <div className="page-content">
                <div className="info-card"><h2>SPPU Scholarships</h2>
                    <ul>
                        <li><strong>Merit Scholarship</strong> — For students ranking in top 10 in university examinations.</li>
                        <li><strong>Physically Handicapped Scholarship</strong> — Special scholarship for PwD students.</li>
                        <li><strong>Sports Scholarship</strong> — For students representing the university in state/national sports events.</li>
                        <li><strong>Cultural Activities Scholarship</strong> — For meritorious cultural performers.</li>
                    </ul>
                    <p style={{ marginTop: '1rem' }}>For more details, contact the college scholarship desk or visit the SPPU scholarship portal.</p>
                    <div className="ext-links">
                        <a href="https://www.unipune.ac.in" target="_blank" rel="noreferrer" className="ext-link-chip">🔗 SPPU Website</a>
                    </div>
                </div>
            </div>
            <Footer /></div>
    );
}

// ── Board of Student Development (BSW)
export function BoardStudentDevelopment() {
    return (
        <div className="page-wrapper"><Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Students Corner › Board of Student Development</p>
                <h1>Board of Student Welfare (BSW)</h1><p>Dedicated to the holistic welfare and development of students.</p>
            </div>
            <div className="page-content">
                <div className="info-card"><h2>About BSW</h2>
                    <p>The Board of Student Welfare (BSW) at Shri Mulikadevi Mahavidyalaya coordinates all student welfare activities including cultural programs, sports, NSS, and student council elections. It serves as the primary channel between students and the college administration.</p>
                </div>
                <div className="info-card"><h2>Key Activities</h2>
                    <ul>
                        <li>Organizing annual cultural fest and sports events.</li>
                        <li>Student Council elections and governance.</li>
                        <li>Coordinating with NSS unit for community service programs.</li>
                        <li>Managing student grievances and welfare schemes.</li>
                        <li>Educational tours and industrial visits.</li>
                    </ul>
                </div>
            </div>
            <Footer /></div>
    );
}

// ── Academic Calendar
export function AcademicCalendar() {
    const events = [
        { month: 'June', event: 'Academic Year Begins, Admission Process' },
        { month: 'July', event: 'Orientation Program, Regular Classes Begin' },
        { month: 'August', event: 'Independence Day Celebration, NSS Activities' },
        { month: 'September', event: 'Internal Examinations (Unit Tests)' },
        { month: 'October', event: 'Diwali Vacation, Cultural Events' },
        { month: 'November', event: 'Annual Sports Meet' },
        { month: 'December', event: 'Semester-End Internal Examinations' },
        { month: 'January', event: 'Republic Day, External Examinations Begin' },
        { month: 'February', event: 'Annual Cultural Fest "Utkarsh"' },
        { month: 'March', event: 'External Examinations (University)' },
        { month: 'April', event: 'Results Declaration, Farewell Programs' },
        { month: 'May', event: 'Summer Vacation, NSS Annual Camp' },
    ];
    return (
        <div className="page-wrapper"><Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Students Corner › Academic Calendar</p>
                <h1>Academic Calendar</h1><p>Key dates and events for the current academic year.</p>
            </div>
            <div className="page-content">
                <div className="info-card"><h2>Academic Year Overview</h2>
                    <table className="data-table">
                        <thead><tr><th>Month</th><th>Key Events</th></tr></thead>
                        <tbody>{events.map(e => <tr key={e.month}><td style={{ fontWeight: 600 }}>{e.month}</td><td>{e.event}</td></tr>)}</tbody>
                    </table>
                    <p style={{ fontSize: '0.83rem', color: '#999', marginTop: '0.8rem' }}>* For the official SPPU-published academic calendar, visit the <a href="https://www.unipune.ac.in" target="_blank" rel="noreferrer" style={{ color: '#2d6a4f' }}>SPPU website</a>.</p>
                </div>
            </div>
            <Footer /></div>
    );
}

// ── Study Material
export function StudyMaterial() {
    return (
        <div className="page-wrapper"><Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Students Corner › Study Material</p>
                <h1>Study Material</h1><p>Downloadable notes, e-content, and reference materials uploaded by faculty.</p>
            </div>
            <div className="page-content">
                <div className="info-card"><h2>Study Resources</h2><p style={pgStyle}>📌 Study materials are uploaded by faculty department-wise. Please log in with your student account to access and download study materials for your enrolled courses.</p>
                    <a href="/login" className="download-btn">🔐 Login to Access</a>
                </div>
            </div>
            <Footer /></div>
    );
}

// ── Caste-Based Discrimination
export function CasteDiscrimination() {
    return (
        <div className="page-wrapper"><Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Students Corner › Caste-Based Discrimination</p>
                <h1>Prevention of Caste-Based Discrimination</h1><p>Committed to an inclusive, discrimination-free campus.</p>
            </div>
            <div className="page-content">
                <div className="info-card"><h2>College Policy</h2>
                    <p>Shri Mulikadevi Mahavidyalaya, Nighoj is committed to maintaining a campus free from all forms of caste-based discrimination, as mandated by the University Grants Commission (UGC) and the Prevention of Atrocities Act. Any form of discrimination based on caste, religion, gender, or socio-economic background is strictly prohibited.</p>
                </div>
                <div className="info-card"><h2>Reporting a Complaint</h2>
                    <p>Students who face any form of caste-based discrimination are encouraged to report it through:</p>
                    <ul>
                        <li>The Students' Grievance Redressal Cell: <a href="/grievance-cell" style={{ color: '#2d6a4f' }}>Click here</a></li>
                        <li>Directly to the Principal's Office: (02488) 230438</li>
                        <li>Email: <a href="mailto:ascnighoj@gmail.com" style={{ color: '#2d6a4f' }}>ascnighoj@gmail.com</a></li>
                    </ul>
                </div>
            </div>
            <Footer /></div>
    );
}

// ── PowerPoint Bank
export function PowerPointBank() {
    return (
        <div className="page-wrapper"><Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Students Corner › PowerPoint Bank</p>
                <h1>PowerPoint Bank</h1><p>Teaching presentations created by faculty for student reference.</p>
            </div>
            <div className="page-content">
                <div className="info-card"><h2>Access PPTs</h2><p style={pgStyle}>📌 Faculty-created PowerPoint presentations are available here. Please log in to access and download presentations relevant to your course and department.</p>
                    <a href="/login" className="download-btn">🔐 Login to Access</a>
                </div>
                <div className="info-card"><h2>ICT Resources</h2>
                    <p>For more ICT-related resources, visit the <a href="/ict-facilities" style={{ color: '#2d6a4f' }}>ICT Facilities</a> page.</p>
                </div>
            </div>
            <Footer /></div>
    );
}

export default EnrollmentList;
